<template>
  <div>
    <app-header title="">
      <template v-slot:actions>
        <button
          type="button"
          class="btn btn-primary mt-2 mt-xl-0"
          v-c-modal:createModal="{}"
        >
          <i class="far fa-plus"></i> Application
        </button>
      </template>
    </app-header>

    <div class="container my-5">
      <h2>Applications</h2>

      <applications-list-filters v-model="params" />

      <c-data-list :items="applications" @load="loadNextPage">
        <template v-slot:columns>
          <div class="col-12 col-lg-8">
            <p>Client / Application</p>
          </div>
          <div class="col-6 col-lg-4 text-end">
            <p>PI Billing</p>
          </div>
        </template>
        <template v-slot:default="slotProps">
          <applications-list-item :application="slotProps.item" />
        </template>
        <template v-slot:empty>
          No applications to show.
        </template>
      </c-data-list>
    </div>

    <application-create-modal
      ref="createModal"
      :clients="clients"
      :projects="projects"
      :clusters="clusters"
      @created="applicationCreated"
    />
  </div>
</template>

<script>
import { isEqual, pickBy, isNil } from 'lodash'
import ApplicationsListItem from './ApplicationsListItem'
import ApplicationsListFilters from './ApplicationsListFilters'
import ApplicationCreateModal from './ApplicationCreateModal'

export default {
  components: {
    ApplicationsListItem,
    ApplicationsListFilters,
    ApplicationCreateModal
  },

  data () {
    return {
      applications: [],
      params: {},
      current_page: 1,
      last_page: 1,
      request: null,
      clients: [],
      projects: [],
      clusters: []
    }
  },

  mounted () {
    this.fetchPage(1)
    this.fetchLists()

    this.$watch('params', (params, oldParams) => {
      if (isEqual(params, oldParams)) {
        return
      }

      this.fetchPage(1)
    })
  },

  methods: {
    fetchPage (page) {
      const query = new URLSearchParams({ ...pickBy(this.params, value => !isNil(value)), page }).toString()

      this.request = client({ path: '/applications?' + query }).then((response) => {
        const data = response.entity

        this.applications = page === 1 ? data.data : this.applications.concat(data.data)
        this.current_page = data.current_page
        this.last_page = data.last_page
      })

      return this.request
    },

    fetchLists () {
      return Promise.all([
        client({ path: '/clients/list' }),
        client({ path: '/projects/list' }),
        client({ path: '/clusters/list' })
      ]).then(([clients, projects, clusters]) => {
        this.clients = clients.entity
        this.projects = projects.entity
        this.clusters = clusters.entity
      })
    },

    async loadNextPage (done) {
      try {
        await this.request

        if (this.current_page >= this.last_page) {
          return done(true)
        }

        await this.fetchPage(this.current_page + 1)

        done()
      } catch (error) {
        done(true)
      }
    },

    applicationCreated () {
      this.fetchPage(1)
    }
  }
}
</script>
